import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { numberFormat, colorFix, formatVolume10 } from '../../utils';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { makeGetSymbolState } from '../../lib/selector';

import { isMobile } from 'react-device-detect';

function DatagridRowLole(props) {
  const [cl, setCl] = useState(null);
  const [bp1Cl, setBp1Cl] = useState(null);
  const [bp2Cl, setBp2Cl] = useState(null);
  const [bp3Cl, setBp3Cl] = useState(null);
  const [sp1Cl, setSp1Cl] = useState(null);
  const [sp2Cl, setSp2Cl] = useState(null);
  const [sp3Cl, setSp3Cl] = useState(null);

  const { record, symbol } = props;

  useEffect(() => {
    const _cl = colorFix(
      record.lastPrice,
      record.r,
      record.c,
      record.f,
      record.r
    );
    const _bp1Cl = colorFix(record.bp1, record.r, record.c, record.f, record.r);
    const _bp2Cl = colorFix(record.bp2, record.r, record.c, record.f, record.r);
    const _bp3Cl = colorFix(record.bp3, record.r, record.c, record.f, record.r);
    const _sp1Cl = colorFix(record.sp1, record.r, record.c, record.f, record.r);
    const _sp2Cl = colorFix(record.sp2, record.r, record.c, record.f, record.r);
    const _sp3Cl = colorFix(record.sp3, record.r, record.c, record.f, record.r);
    setCl(_cl);
    setBp1Cl(_bp1Cl);
    setBp2Cl(_bp2Cl);
    setBp3Cl(_bp3Cl);
    setSp1Cl(_sp1Cl);
    setSp2Cl(_sp2Cl);
    setSp3Cl(_sp3Cl);
  }, [record]);

  return (
    <tr id={record.sym + 'row'}>
      <td className={'text-left ' + cl} id={record.sym + 'sym'}>
        {isMobile ? (
          <a onClick={() => props.handleOpenModal(record.sym)}>{record.sym}</a>
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id={`tooltip-top`}>{symbol && symbol.name_vn}</Tooltip>
            }
          >
            <a onClick={() => props.handleOpenModal(record.sym)}>
              {record.sym}
            </a>
          </OverlayTrigger>
        )}
      </td>
      <td className="text-right high-light r" id={record.sym + 'ceil'}>
        {numberFormat(record.r, 2)}
      </td>
      <td className="text-right high-light c" id={record.sym + 'ref'}>
        {numberFormat(record.c, 2)}
      </td>
      <td className="text-right high-light f" id={record.sym + 'floor'}>
        {numberFormat(record.f, 2)}
      </td>
      <td className={'text-right ' + bp3Cl} id={record.sym + 'bP3'}>
        {numberFormat(record.bp3, 2)}
      </td>
      <td className={'text-right ' + bp3Cl} id={record.sym + 'bV3'}>
        {formatVolume10(record.bv3)}
      </td>
      <td className={'text-right ' + bp2Cl} id={record.sym + 'bP2'}>
        {numberFormat(record.bp2, 2)}
      </td>
      <td className={'text-right ' + bp2Cl} id={record.sym + 'bV2'}>
        {formatVolume10(record.bv2)}
      </td>
      <td className={'text-right ' + bp1Cl} id={record.sym + 'bP1'}>
        {numberFormat(record.bp1, 2)}
      </td>
      <td className={'text-right ' + bp1Cl} id={record.sym + 'bV1'}>
        {formatVolume10(record.bv1)}
      </td>
      <td
        className={'text-right high-light ' + cl}
        id={record.sym + 'lastPrice'}
      >
        {numberFormat(record.lastPrice, 2)}
      </td>
      <td
        className={'text-right high-light ' + cl}
        id={record.sym + 'lastVolume'}
      >
        {formatVolume10(record.lastVolume)}
      </td>
      <td
        id={record.sym + 'change'}
        className={'text-right high-light ' + (record.cl || cl)}
      >
        {record.lastPrice == 0
          ? ''
          : numberFormat(record.lastPrice - record.r, 2)}
      </td>
      <td className={'text-right ' + sp1Cl} id={record.sym + 'oP1'}>
        {numberFormat(record.sp1, 2)}
      </td>
      <td className={'text-right ' + sp1Cl} id={record.sym + 'oV1'}>
        {formatVolume10(record.sv1)}
      </td>
      <td className={'text-right ' + sp2Cl} id={record.sym + 'oP2'}>
        {numberFormat(record.sp2, 2)}
      </td>
      <td className={'text-right ' + sp2Cl} id={record.sym + 'oV2'}>
        {formatVolume10(record.sv2)}
      </td>
      <td className={'text-right ' + sp3Cl} id={record.sym + 'oP3'}>
        {numberFormat(record.sp3, 2)}
      </td>
      <td className={'text-right ' + sp3Cl} id={record.sym + 'oV3'}>
        {formatVolume10(record.sv3)}
      </td>
    </tr>
  );
}

const makeMapStateToProps = () => {
  const getSymbolState = makeGetSymbolState();
  const mapStateToProps = (state, props) => {
    return {
      symbol: getSymbolState(state, props),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps)(DatagridRowLole);
